__turbopack_context__.v({
  "carousel": "sTX3Sa_carousel",
  "carouselOnly": "sTX3Sa_carouselOnly",
  "tipSlide": "sTX3Sa_tipSlide",
  "tipsGrid": "sTX3Sa_tipsGrid",
  "tipsWrapper": "sTX3Sa_tipsWrapper",
});
